/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { transfersControllerCancelTransfer } from "./transfersControllerCancelTransfer";
import { transfersControllerGetMyRun } from "./transfersControllerGetMyRun";
import { transfersControllerGetTransfer } from "./transfersControllerGetTransfer";
import { transfersControllerGetTransferLogs } from "./transfersControllerGetTransferLogs";
import { transfersControllerListTransfers } from "./transfersControllerListTransfers";
import { transfersControllerPatchTransfer } from "./transfersControllerPatchTransfer";
import { transfersControllerResetCustomerMigration } from "./transfersControllerResetCustomerMigration";
import { transfersControllerStartOrgTransfer } from "./transfersControllerStartOrgTransfer";
import { transfersControllerStartTransfer } from "./transfersControllerStartTransfer";

export function transfersService() {
  return { transfersControllerListTransfers, transfersControllerStartTransfer, transfersControllerStartOrgTransfer, transfersControllerGetMyRun, transfersControllerGetTransfer, transfersControllerCancelTransfer, transfersControllerPatchTransfer, transfersControllerResetCustomerMigration, transfersControllerGetTransferLogs }
}